import { createApp } from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight';
import { faAngleLeft } from '@fortawesome/pro-light-svg-icons/faAngleLeft';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import { faAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp';
import { faSlidersSimple } from '@fortawesome/pro-light-svg-icons/faSlidersSimple';
import { faGrid2 } from '@fortawesome/pro-light-svg-icons/faGrid2';
import { faList } from '@fortawesome/pro-light-svg-icons/faList';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo';
import { faCube } from '@fortawesome/pro-light-svg-icons/faCube';
import { faStore } from '@fortawesome/pro-light-svg-icons/faStore';
import { faLocationDot } from '@fortawesome/pro-light-svg-icons/faLocationDot';
import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash';
import { faCartShopping } from '@fortawesome/pro-light-svg-icons/faCartShopping';
import { faSparkles } from '@fortawesome/pro-light-svg-icons/faSparkles';
import { faApple } from '@fortawesome/free-brands-svg-icons/faApple';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle';
import { faBoxTaped } from '@fortawesome/pro-light-svg-icons/faBoxTaped';
import { faFileCertificate } from '@fortawesome/pro-light-svg-icons/faFileCertificate';
import { faClockRotateLeft } from '@fortawesome/pro-light-svg-icons/faClockRotateLeft';
import { faArrowUpRightAndArrowDownLeftFromCenter } from '@fortawesome/pro-light-svg-icons/faArrowUpRightAndArrowDownLeftFromCenter';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight';
import { faPenNib } from '@fortawesome/pro-light-svg-icons/faPenNib';
import { faEye } from '@fortawesome/pro-light-svg-icons/faEye';
import { faStopwatch } from '@fortawesome/pro-light-svg-icons/faStopwatch';
import { faCircleCheck } from '@fortawesome/pro-light-svg-icons/faCircleCheck';
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import { faScaleUnbalanced } from '@fortawesome/pro-light-svg-icons';
import { faRuler } from '@fortawesome/pro-light-svg-icons';
import { faCircleArrowRight } from '@fortawesome/pro-light-svg-icons/faCircleArrowRight';
import { faArrowDownWideShort } from '@fortawesome/pro-light-svg-icons/faArrowDownWideShort';
import { faStars } from '@fortawesome/pro-light-svg-icons/faStars';
import { faGem } from '@fortawesome/pro-light-svg-icons/faGem';
import { faHeart } from '@fortawesome/pro-light-svg-icons/faHeart';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faGift } from '@fortawesome/pro-light-svg-icons/faGift';
import { faLoader } from '@fortawesome/pro-light-svg-icons/faLoader';
import { faRingDiamond } from '@fortawesome/pro-light-svg-icons/faRingDiamond';
import { faTrashCheck } from '@fortawesome/pro-light-svg-icons/faTrashCheck';
import { faCircleUser } from '@fortawesome/pro-light-svg-icons/faCircleUser';
import { faUser } from '@fortawesome/pro-light-svg-icons/faUser';
import { faCircleChevronDown } from '@fortawesome/pro-light-svg-icons/faCircleChevronDown';
import { faHouse } from '@fortawesome/pro-light-svg-icons/faHouse';
import { faCircleX } from '@fortawesome/pro-light-svg-icons/faCircleX';
import { faCartShoppingFast } from '@fortawesome/pro-light-svg-icons/faCartShoppingFast';
import { faTruckFast } from '@fortawesome/pro-light-svg-icons/faTruckFast';
import { faCirclePlay } from '@fortawesome/pro-light-svg-icons/faCirclePlay';
import { faShieldPlus } from '@fortawesome/pro-light-svg-icons/faShieldPlus';
import { faCreditCard } from '@fortawesome/pro-light-svg-icons/faCreditCard';
import { faBadgePercent } from '@fortawesome/pro-light-svg-icons/faBadgePercent';
import { faPen } from '@fortawesome/pro-light-svg-icons/faPen';
import { faArrowTurnDownRight } from '@fortawesome/pro-light-svg-icons/faArrowTurnDownRight';
import { faBookmark } from '@fortawesome/pro-light-svg-icons/faBookmark';
import { faLock } from '@fortawesome/pro-light-svg-icons/faLock';
import { faShieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck';
import { faShieldSlash } from '@fortawesome/pro-light-svg-icons/faShieldSlash';
import { faMinus } from '@fortawesome/pro-light-svg-icons/faMinus';
import { faCloudArrowDown } from '@fortawesome/pro-light-svg-icons/faCloudArrowDown';
import { faCloudArrowUp } from '@fortawesome/pro-light-svg-icons/faCloudArrowUp';
import { faBadgeCheck } from '@fortawesome/pro-light-svg-icons/faBadgeCheck';
import { faHeadset } from '@fortawesome/pro-light-svg-icons/faHeadset';
import { faLoveseat } from '@fortawesome/pro-light-svg-icons/faLoveseat';
import { faFillDrip } from '@fortawesome/pro-light-svg-icons/faFillDrip';
import { faFileArrowDown } from '@fortawesome/pro-light-svg-icons/faFileArrowDown';
import { faMagnifyingGlassPlus } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlassPlus';
import { faBars } from '@fortawesome/pro-light-svg-icons/faBars';
import { faBellConcierge } from '@fortawesome/pro-light-svg-icons/faBellConcierge';
import { faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons/faStar';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass';
import { faLockKeyhole } from '@fortawesome/pro-light-svg-icons/faLockKeyhole';
import { faCopy } from '@fortawesome/pro-light-svg-icons/faCopy';

import { makeImg } from '@vuejs/utils/makeImg';
import { roundCaratNumber } from '@vuejs/utils/roundCaratNumber';
import { lazyLoadedVideoController } from '@vuejs/utils/lazyLoadedVideoController';
import { formatPrice } from '@vuejs/utils/formatPrice';
import { numberFormat } from '@vuejs/utils/numberFormat';
import { altImage } from '@vuejs/utils/altImage';
import { createFormData } from '@vuejs/utils/createFormData';

import { faArrowUpArrowDown } from '@fortawesome/pro-light-svg-icons/faArrowUpArrowDown';
import { faArrowsRotateReverse } from '@fortawesome/pro-light-svg-icons/faArrowsRotateReverse';
// import { makeImg } from '@vuejs/utils/makeImg';

import { faStar } from '@fortawesome/pro-light-svg-icons/faStar';
import { faThumbsUp } from '@fortawesome/pro-light-svg-icons/faThumbsUp';
import { faThumbsDown } from '@fortawesome/pro-light-svg-icons/faThumbsDown';
import { faPenToSquare } from '@fortawesome/pro-light-svg-icons/faPenToSquare';

import SavickiDesignSystem from '@sylapi/savicki-design-system/dist/savicki-design-system';

library.add(
    faAngleRight,
    faAngleLeft,
    faSlidersSimple,
    faGrid2,
    faList,
    faXmark,
    faAngleDown,
    faAngleUp,
    faChevronDown,
    faChevronUp,
    faChevronLeft,
    faCircleInfo,
    faCircleExclamation,
    faCube,
    faStore,
    faLocationDot,
    faTrash,
    faCartShopping,
    faSparkles,
    faApple,
    faFacebookF,
    faGoogle,
    faBoxTaped,
    faFileCertificate,
    faClockRotateLeft,
    faArrowUpRightAndArrowDownLeftFromCenter,
    faPenNib,
    faCircleCheck,
    faScaleUnbalanced,
    faRuler,
    faCircleArrowRight,
    faArrowDownWideShort,
    faStar,
    faStarSolid,
    faStars,
    faGem,
    faPlus,
    faCheck,
    faArrowRight,
    faEye,
    faGift,
    faLoader,
    faRingDiamond,
    faStopwatch,
    faTrashCheck,
    faCircleUser,
    faUser,
    faArrowUpArrowDown,
    faCircleChevronDown,
    faChevronRight,
    faHouse,
    faCircleX,
    faTruckFast,
    faCirclePlay,
    faArrowsRotateReverse,
    faShieldPlus,
    faCreditCard,
    faBadgePercent,
    faPen,
    faBookmark,
    faArrowTurnDownRight,
    faLock,
    faShieldSlash,
    faMinus,
    faHouse,
    faCartShoppingFast,
    faThumbsUp,
    faThumbsDown,
    faPenToSquare,
    faCloudArrowDown,
    faBadgeCheck,
    faHeart,
    faHeadset,
    faShieldCheck,
    faLoveseat,
    faFillDrip,
    faFileArrowDown,
    faCloudArrowUp,
    faMagnifyingGlassPlus,
    faBars,
    faBellConcierge,
    faMagnifyingGlass,
    faLockKeyhole,
    faCopy
);

export const createVueApp = (Component, config = {}) => {
    const app = createApp(Component);

    app.use(SavickiDesignSystem, { locale: window.config.language.locale });

    app.config.globalProperties.$t = window.translate;
    app.config.globalProperties.$formatPrice = formatPrice;
    app.config.globalProperties.$resource_url = window.resource_url;
    app.config.globalProperties.$altImage = altImage;
    app.provide('trans', window.translate);
    app.provide('formatPrice', formatPrice);
    app.provide('makeImg', makeImg);
    app.provide('roundCaratNumber', roundCaratNumber);
    app.provide('numberFormat', numberFormat);
    app.provide('resource_url', window.resource_url);
    app.provide('altImage', altImage);
    app.provide('lazyLoadedVideoController', lazyLoadedVideoController);
    app.provide('createFormData', createFormData);

    if (config.globalState) {
        Object.entries(config.globalState).forEach(([key, value]) => {
            app.provide(key, value);
        });
    }

    app.component('font-awesome-icon', FontAwesomeIcon);

    return app;
};
